import { CheckCircle2, X } from "lucide-react";
import { useEffect } from "react";

interface LogoutSuccessModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export default function LogoutSuccessModal({
    isOpen,
    onClose
}: LogoutSuccessModalProps) {

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            const timer = setTimeout(onClose, 2000);
            return () => {
                clearTimeout(timer);
                document.body.style.overflow = 'unset';
            };
        }
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />

            <div className="relative bg-card border border-border/50 shadow-2xl rounded-2xl p-8 max-w-md w-full mx-4 animate-in fade-in zoom-in-95 duration-300">
                <button onClick={onClose} className="absolute right-4 top-4 p-2 hover:bg-muted rounded-full transition-colors">
                    <X className="w-4 h-4" />
                </button>

                <div className="text-center">
                    <div className="mb-6">
                        <div className="w-16 h-16 mx-auto bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full flex items-center justify-center shadow-lg">
                            <CheckCircle2 className="w-8 h-8 text-white" />
                        </div>
                    </div>

                    <h2 className="text-2xl font-bold mb-4">
                        <span className="bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
                            Logout realizado!
                        </span>
                    </h2>

                    <p className="text-muted-foreground leading-relaxed">
                        Você saiu da sua conta com sucesso.
                    </p>
                </div>
            </div>
        </div>
    );
}